module.exports = __webpack_public_path__ + "static/media/amazon.aa59f262.svg";